#import "../../session-assignation/graphql/sessionCrudResult.fragment.graphql"

mutation submitAssignmentProposal(
  $scenarioId: ID!
  $originId: ID!
  $input: SubmitAssignmentProposalInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    submitAssignmentProposal(input: $input) {
      proposalId
      state
      errorCode
      unsupportedSessionId
      validation {
        ...SessionCrudResultFields
        __typename
      }
      __typename
    }
    __typename
  }
}
